import type { LocationQueryValue } from 'vue-router';
import { isAppInter } from '@/helpers/isAppInter';
import { sessionService, themeService } from '@/services';

/** `utm_source` com que o card do SuperApp do Inter marca quem manda para cá. */
const UTM_SOURCE_APP_INTER = 'app_inter';

/**
 * As três checagens são independentes: `ThemeService.normalizeTheme` força o SuperApp para o tema
 * `portal`, e `?tema=inter` no domínio da Acerto não chega ao GrowthBook, que só vê o host do login.
 *
 * `temaQuery` é opcional porque `themeService.loadTheme()` roda depois de `app.use(router)`: quem tem
 * a rota em mãos passa `to.query.tema` para não depender dessa ordem.
 *
 * Sem o `utm_medium` que o `ThemeService` exige: lá a pergunta é "qual tema pintar", aqui é "de onde veio".
 */
export function isOrigemInter(temaQuery?: LocationQueryValue | LocationQueryValue[]): boolean {
  return (
    isAppInter(temaQuery) ||
    themeService.isInterTheme() ||
    sessionService.token?.payload?.utmSource === UTM_SOURCE_APP_INTER
  );
}
